import { render } from "./Index.vue?vue&type=template&id=3c6aebe9&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=3c6aebe9&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6aebe9"],['__file',"src/assets/js/pages/Address/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c6aebe9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c6aebe9', __exports__)) {
    api.reload('3c6aebe9', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3c6aebe9&scoped=true", () => {
    api.rerender('3c6aebe9', render)
  })

}


export default __exports__